import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/ui/LightRays/light-rays.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/layout/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/layout/header.tsx");
